// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-js" + "-" + "537146cab3e9897428ba" + ".js";
};